<template>
  <div class="send-boxstatus">
    <i-spin v-if="loading || bindFedexLoading" fix>
      <i-icon type="ios-loading" size="40" class="spin-icon-load" />
    </i-spin>
    <template v-else>
      <template>
        <p class="title">Box status</p>
        <ul v-for="(box, index) in boxStatus" :key="index" class="box-status">
          <li class="box-item">
            <div v-for="item in box.boxList" :key="item.trkNum" class="row">
              <span class="num">#{{ item.boxNum }}</span>
              <div class="content">
                <div class="content-row">
                  <span class="tip">Tracking #</span>
                  <div class="number">
                    <span>{{ item.trkNum }}</span>
                    <img
                      v-if="box.status === 'Sending' || box.status === 'Returning'"
                      class="btn icon"
                      src="../../../assets/imgs/send-localtion.png"
                      alt="send location icon"
                      @click="fedexDetail(item, box)"
                    />
                  </div>
                </div>
                <div class="content-row">
                  <span v-if="box.status !== 'Unsent'" class="status-lable">Status</span>
                  <div class="status-info">
                    <span v-if="box.status === 'Sending'" class="status">In transit</span>
                    <span v-else-if="box.status !== 'Storing' && box.status !== 'Unsent'" class="status">
                      {{ box.statusText }}
                    </span>
                    <div v-else-if="box.status === 'Storing'" class="day">
                      <img style="height: 16px;width: 16px;margin: 0 4px 2px 0;" src="../../../assets/imgs/time.png" />
                      <span>{{ item.storedDays }}</span>
                    </div>
                  </div>
                  <Button v-if="box.status === 'Unsent'" size="large" class="btn" @click="downLoadPdf(item.trkNum)">
                    <div><i-icon class="d-cion" type="md-download" />Label</div>
                  </Button>
                </div>
              </div>
            </div>
            <div v-if="box.status === 'Storing'" class="edit-info">
              <template v-if="box.backId === 0">
                <span class="tips-title">You have {{ box.boxList.length }} {{ box.boxList.length > 1 ? 'packages' : 'package' }} in storage</span>
                <div class="tips">
                  <p>
                    We will charge a storage fee to your credit card every 7 days. If you need to return, please make an
                    appointment at least 5 working days in advance
                  </p>
                </div>
                <mk-button
                  type="primary"
                  :disabled="sendInfo.payFailed"
                  style="width: 200px; height: 36px; margin-top: 25px;"
                  @click="scheduleReturn(box)"
                >
                  Schedule to return
                </mk-button>
              </template>
              <template v-else-if="box.canCancel && box.needPay">
                <span class="tips-title">Awaiting to pay</span>
                <div class="tips">
                  Please continue to pay the return order. If changes are needed, please cancel and reorder. If pay
                  failed, please change your payment method.
                </div>
                <div class="btns">
                  <Button class="default cbtn" size="large" @click="cancelReturn(box)">Cancel</Button>
                  <Button class="cbtn" size="large" style="margin-left: 20px;" @click="continueToPay(box)">
                    Continue to pay
                  </Button>
                </div>
              </template>
              <template v-else-if="box.canCancel && !box.needPay">
                <span class="tips-title">Awaiting to return</span>
                <div class="tips">
                  According to your return request, we will send out your packages on
                  <span class="date">{{ box.boxList[0].leaveLdt }}</span>
                  . Please confirm your travel plan in advance.
                </div>
                <div class="btns">
                  <Button class="default cbtn" size="large" @click="cancelReturn(box)">Cancel</Button>
                  <!--<Button class="cbtn" size="large" @click="updateReturn(box)">Update</Button>-->
                  <!--<Button class="cbtn" size="large" @click="changeBackDetailDraw(box.backId)">Return details</Button>-->
                </div>
              </template>
              <template v-else>
                <span class="tips-title">Prepare for shipping</span>
                <div class="tips">
                  Your package will be shipped soon and is expected to deliver your destination in
                  {{ box.transDay }} days.
                </div>
              </template>
            </div>
            <div v-if="box.backId" class="back-info">
              <span class="address">Return To {{ box.boxList[0].backAddr }}</span>
              <span class="btn detail" @click="changeBackDetailDraw(box.backId)">Return details ></span>
            </div>
          </li>
        </ul>
      </template>
      <bill-list />
      <div v-if="boxWeights.length > 0" class="weight-info">
        <p class="title">Inbound information</p>
        <div class="weight-list box-status">
          <div class="inbound-tips">
            <p>
              Your package storage fee is calculated based on rated weight. The rated weight is the greater of the
              actual weight or the dimensional weight
            </p>
            <p>Dimensional weight = (L*W*H)/139</p>
          </div>
          <div v-for="weight in boxWeights" :key="weight.trkNum" class="box-item">
            <div class="row">
              <span class="num">#{{ weight.boxNum }}</span>
              <div class="content">
                <div class="content-row">
                  <span class="tip">Tracking #</span>
                  <div class="number">
                    <span>{{ weight.sendTrkNum }}</span>
                  </div>
                </div>
                <div class="content-row info">
                  <span class="status-lable">Checked-in on {{ weight.storedDate }}</span>
                  <div class="weight">
                    <i-poptip transfer trigger="hover" placement="right">
                      <p class="rated-weight">
                        Rated Weight: {{ weight.weightPay }}LB
                        <img src="../../../assets/imgs/gengduo.png" />
                      </p>
                      <div slot="content">
                        <p>Actual Weight: {{ weight.weightRaw }} LB</p>
                        <p>Dimension: {{ weight.length }}*{{ weight.width }}*{{ weight.height }} inch</p>
                        <p>Dimensional Weight: {{ weight.weightDim }} LB</p>
                      </div>
                    </i-poptip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <i-drawer v-model="backDetailDrawerShow" width="544">
        <template slot="header">
          <span style="font-size: 18px; font-family: 'Montserrat-Light';">Return details</span>
        </template>
        <div style="padding: 10px 20px">
          <FedexReturn :back-id="backDetailDrawerId" />
        </div>
      </i-drawer>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Button from '../../../components/button/Button';
import { API } from '@/net/http';
import FedexReturn from '../../../components/fedex/FedexReturn';
import BillList from '@/views/bill/BillList.vue';
import MkButton from '@/components/button/MkButton.vue';

export default {
  name: 'BoxStatus',
  components: {
    MkButton,
    BillList,
    Button,
    FedexReturn,
  },
  data() {
    return {
      loading: true,
      loadingPayment: true,
      boxStatus: [],
      bindFedexError: false,
      label: true,
      boxWeights: [],
      backDetailDrawerShow: false,
      backDetailDrawerId: null,
    };
  },
  computed: {
    ...mapState('send', ['sendInfo', 'bindedFedex', 'bindFedexLoading']),
  },
  async mounted() {
    await this.init();
    if (this.$route.query.type === 'return') {
      this.initReturn();
    }
  },
  methods: {
    async init() {
      if (this.sendInfo) {
        let orderNum = this.sendInfo.orderNum;
        this.loading = true;
        this.$emit('change-loading', true);

        if (this.sendInfo.payFailed) this.$emit('change-payment-failed', true);

        return this.$post(API.orderStatusLuggage, {
          orderNum: orderNum,
        })
          .then(res => {
            if (res.success) {
              this.loading = false;
              this.$emit('change-loading', false);
              if (this.bindedFedex) {
                let status = res.data,
                  boxWeights = [];
                //如果只有unsent状态的包裹并且都没有tracking#，则提示fedex异常
                let onlyUnsent = status.length === 1 && status[0].status === 'Unsent';
                let noTracking = true;
                if (onlyUnsent) {
                  status[0].boxList.forEach(item => {
                    if (noTracking && item.sendTrkNum) {
                      noTracking = false;
                    }
                  });
                }
                if (onlyUnsent && noTracking) {
                  this.bindFedexError = true;
                  return;
                } else {
                  this.bindFedexError = false;
                }
                status.forEach(box => {
                  box.boxList.forEach(item => {
                    if (item.weightRaw) {
                      boxWeights.push(item);
                    }
                  });
                  if (box.status !== 'Unsent') {
                    this.label = false;
                  }
                });
                boxWeights.sort((a, b) => a.boxNum < b.boxNum);
                this.boxWeights = boxWeights;
                this.boxStatus = status;
              }
            } else {
              this.$Message.error(res.message);
            }
          })
          .catch(() => {
            this.$emit('change-loading', false);
            this.loading = false;
          });
      }
    },
    /**
     * 处理通过return链接直接进入页面的情况
     * 在页面初始化后直接模拟点击“Schedule to return”按钮
     */
    initReturn() {
      for (let box of this.boxStatus) {
        //此处的判断条件来自“Schedule to return”按钮的判断逻辑
        if (box.status === 'Storing' && box.backId === 0 && !this.sendInfo.payFailed){
          this.scheduleReturn(box);
          return;
        }
      }
    },
    downLoadPdf(truckNum) {
      window.open(`/order/label/res-id-${truckNum}.pdf`);
    },
    fedexDetail(trk, box) {
      if (box.status === 'Sending' || box.status === 'Returning') {
        window.open(`${process.env.VUE_APP_FEDEX}${trk.trkNum}`);
      }
    },
    scheduleReturn(box) {
      this.$emit('scheduleReturn', box);
    },
    updateReturn(box) {
      this.$emit('scheduleReturn', box);
    },
    cancelReturn(box) {
      this.$Modal.confirm({
        title: 'Are you sure cancel ?',
        cancelText: 'NO',
        okText: 'YES',
        onCancel() {},
        onOk: () => {
          this.loading = true;
          this.$emit('change-loading', true);
          this.$post(API.orderBackCancel, {
            backId: box.backId,
          })
            .then(res => {
              this.loading = false;
              this.$emit('change-loading', false);
              if (res.success) {
                this.init();
              } else {
                this.$Message.error({
                  duration: 3,
                  content: res.message,
                });
              }
            })
            .catch(() => {
              this.$emit('change-loading', false);
              this.loading = false;
            });
        },
      });
    },
    continueToPay(box) {
      this.$emit('push-to-receive-pay', box.backId);
    },
    changeBackDetailDraw(backDetailDrawerId) {
      this.backDetailDrawerId = backDetailDrawerId;
      this.backDetailDrawerShow = !this.backDetailDrawerShow;
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../../assets/css/main.less';
@import '../../../assets/fonts/font.less';
.send-boxstatus {
  position: relative;
  min-height: 600px;
  .title {
    .font-regular;
    font-size: 16px;
    font-weight: 400;
    color: #262626;
    line-height: 19px;
  }
  .box-status {
    border-radius: 4px;
    border: 1px solid #eeeff0;
    margin-top: 20px;
    .box-item {
      &:last-child,
      &.storing {
        .row {
          border-bottom: 0 solid #eeeff0;
        }
      }
      .row {
        margin: 0 24px;
        height: 90px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #eeeff0;
        &:last-child {
          .content {
            border-bottom: 0 solid #eeeff0;
          }
        }
        &.total {
          .font-regular;
          justify-content: flex-end;
          font-size: 16px;
          font-weight: 400;
          color: @app-black-color;
        }
        .num {
          .font-regular;
          width: 56px;
          font-size: 18px;
          font-weight: 400;
          color: #262626;
        }
        .content {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #eeeff0;
          .content-row {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            line-height: 18px;
            .status-info {
              padding-top: 10px;
            }
            .tip,
            .status-lable {
              .font-light;
              font-size: 14px;
              font-weight: 300;
              color: @app-body-color;
            }
            .status-lable {
              text-align: right;
            }
            .number {
              .font-regular;
              font-size: 16px;
              font-weight: 400;
              padding-top: 10px;
              display: flex;
              align-items: center;
              .icon {
                margin-left: 10px;
                width: 17px;
                height: 16px;
              }
            }
            .day {
              .font-regular;
              display: flex;
              flex-direction: row;
              align-items: center;
              font-size: 16px;
              font-weight: 400;
              color: @app-color;
              .icon {
                font-size: 20px;
                margin-right: 6px;
              }
            }
            .status {
              .font-regular;
              font-size: 16px;
              font-weight: 400;
              color: @app-black-color;
            }
            .btn {
              border-radius: 18px;
              .d-cion {
                font-size: 13px;
                margin-right: 6px;
              }
            }
            .weight {
              .font-regular;
              font-size: 16px;
              font-weight: 400;
              padding-top: 10px;
              text-align: right;
              color: @app-black-color;
              .rated-weight {
                img {
                  margin-left: 4px;
                  width: 16px;
                  height: 10px;
                }
              }
            }
          }
        }
      }
      .edit-info {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background: #edf9f9;
        color: #66cccc;
        padding: 24px 30px;
        .tips-title {
          .font-bold;
          font-size: 14px;
          font-weight: 700;
        }
        .tips {
          margin-top: 10px;
          .font-light;
          font-size: 12px;
          font-weight: 300;
          .date {
            .font-regular;
          }
        }
        .btns {
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          margin-top: 25px;
          .cbtn {
            border-radius: 18px;
            &.default {
              //margin-right: 56px;
              background-color: transparent;
              color: @app-color;
              border: 1px solid @app-color;
            }
          }
        }
      }
      .back-info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background: #edf9f9;
        border-top: 1px solid #eeeff0;
        padding: 14px 22px;
        .detail {
          color: @app-color;
        }
      }
    }
  }
  .weight-info {
    margin-top: 36px;
    .weight-list {
      margin-top: 20px;
      border-radius: 4px;
      border: 1px solid #eeeff0;
      .row-item {
        padding: 0 24px;
      }
    }
    .inbound-tips {
      .font-light;
      background: #fff6f2;
      border-radius: 3px 3px 0 0;
      padding: 10px 12px;
      p {
        font-size: 12px;
        font-weight: 300;
        color: #afb5c6;
        line-height: 20px;
      }
    }
  }
}
</style>
